var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.883,
    height: 17.822,
    viewBox: "0 0 13.883 17.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    "data-name": "\\u30D1\\u30B9 10",
    d: "M-3049.149-15.179A6.978,6.978,0,0,1-3056-22.119v-2.667a1.08,1.08,0,0,1,1.082-1.074h.091v-1.362A5.779,5.779,0,0,1-3049.05-33a5.782,5.782,0,0,1,5.76,5.777v1.362h.09a1.08,1.08,0,0,1,1.083,1.074v2.511a7.225,7.225,0,0,1-2.141,5.1,6.835,6.835,0,0,1-4.809,2Zm-6.31-9.608v2.667a6.429,6.429,0,0,0,6.318,6.4,6.172,6.172,0,0,0,4.5-1.845,6.643,6.643,0,0,0,1.994-4.71v-2.511a.54.54,0,0,0-.55-.533h-11.717A.533.533,0,0,0-3055.459-24.787Zm10.421-2.437v1.362h1.214v-1.362a5.24,5.24,0,0,0-5.226-5.226,5.25,5.25,0,0,0-5.251,5.226v1.362h1.231v-1.362a4.026,4.026,0,0,1,4.021-4.012A4.029,4.029,0,0,1-3045.038-27.224Zm-7.491,0v1.362h6.95v-1.362a3.482,3.482,0,0,0-3.471-3.47A3.473,3.473,0,0,0-3052.529-27.224Zm2.387,8.705a.267.267,0,0,1-.205-.09.287.287,0,0,1-.057-.229l.394-2.208a1.339,1.339,0,0,1-.4-.952,1.356,1.356,0,0,1,1.354-1.355A1.349,1.349,0,0,1-3047.713-22a1.31,1.31,0,0,1-.4.952l.4,2.208a.3.3,0,0,1-.066.229.268.268,0,0,1-.206.09Zm.271-3.478a.812.812,0,0,0,.32.639.27.27,0,0,1,.1.255l-.369,2.051h1.517l-.369-2.051a.268.268,0,0,1,.1-.255.815.815,0,0,0,.32-.639.807.807,0,0,0-.8-.813A.809.809,0,0,0-3049.871-22Z",
    transform: "translate(3056 33)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.abd0ccdc14f62d2dc09d707170faadda.svg";
export { ForwardRef as ReactComponent };